export default function parseContentDisposition({ header }) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(header);
  const filename = matches[1].replace(/['"]/g, '');

  return {
    filename,
  };
}
